import { Breadcrumbs, Loader } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type { FC } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { AccountSetting } from "~/components/specifics/vendors/settings/accounts/AccountSetting";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: FC = () => {
	const { data: session } = useSessions().index();

	if (session === null) {
		return <Loader />;
	}

	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "アカウント詳細" }
						]}
					/>
				</div>
				<AccountSetting session={session} />
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
